import { Horario } from '@tivic-team/manager-ts/dist/mob/entities/horario/horario.entity';
import { LinhaTrecho } from '@tivic-team/manager-ts/dist/mob/entities/linha/linha-trecho.entity';
import { Parada } from '@tivic-team/manager-ts/dist/mob/entities/parada/parada.entity';
import { Plataforma } from '@tivic-team/manager-ts/dist/mob/entities/plataforma/plataforma.entity';
import { Terminal } from '@tivic-team/manager-ts/dist/mob/entities/terminal/terminal.entity';

export class LinhaTrechoDTO extends LinhaTrecho{

    parada: Parada;
    terminal: Terminal;
    plataforma: Plataforma;
    horarios: Horario[];

    constructor(
        plataforma?: Plataforma,
        terminal?: Terminal,
        parada?: Parada
    ) {
        super();
        this.parada = parada;
        this.terminal = terminal;
        this.plataforma = plataforma;
    }

}

export class LinhaTrechoListDTO {
    items: Array<LinhaTrechoDTO>;
    total: number;
    constructor() {}
}